module.exports = {
  home: {
    welcome: 'WELCOME TO',
    welcome2: ' Customer Service Platform',
    intro1: "We are a laser equipment manufacturing organization with ",
    year: "years of experience",
    and: " and ",
    people: "numerous talents",
    intro2: "",
    look: "TAKE A LOOK AT OUR",
    bpin: "Bodor+3.0 is a new interactive platform for the laser industry and the Internet of Things, creating a new ecosystem of comprehensive services for laser processing",
    web: "Web Services",
    webin: "The web end provides you with a variety of services with detailed functions. Bodor+has now been updated to the third generation, with a wide range of business and benefits worldwide",
    app: "Mobile APP",
    appin: "The Bodor+mobile app is designed and developed by a professional team, and after multiple investigations and analyses, it covers various aspects such as data collection and device monitoring",
    monitor: "Equipment monitoring",
    monitorin: "After binding the machine tool, 24-hour uninterrupted monitoring of equipment data ensures that it is presented to you in the first time, and a reliable data transmission system safeguards your safety",
    dc: "data collection",
    dcin: "While providing you with processing time statistics and other processing data, we also visually display various data visualization methods for you",
    area: "' AREA",
    machinery: "Construction Machinery",
    advert: "Advertising Signage",
    fitness: "Fitness Machine",
    air: "Air Conditioning",
    architectural: "Architectural Decoration",
    car: "Automobile Making",
    steel: "Steel Structure",
    ship: "Shipbuilding",
    mesin: "BodorMes is a production execution intelligent manufacturing system independently developed by the Bodor R&D team, aimed at individual, small and medium-sized, large, and overseas processing users. It helps users improve efficiency in management, production, quality, and delivery, making their production more transparent, visual, and quantifiable",
    steelstructure: "Steel structure",
    solution: "solution",
    solutionin: "Traditionally, engineers first need to understand how many profiles are needed for the factory project and the priority of producing cut parts. At the same time, procurement personnel make engineering budgets, while production workshop engineers need to consider whether to estimate the maximum processing efficiency of equipment, monitor the production process, conduct daily workpiece statistics and equipment operation statistics, and other issues",
    withmes: "After using BodorMES, you can",
    project: "Create project",
    projectin: "Automatically split various components",
    file: "Export files",
    filein: "Using BodorCAM for Material Cutting Management",
    order: "Issue production order",
    orderin: "Intelligent synchronous production order",
    control: "Progress control",
    controlin: "Fully control the current processing progress",
    increase1: "' ",
    increase2: "INCREASE",
    gain: "Gain obtained",
    average1: "Average increase",
    average1in1: "Accelerate collaborative response",
    average1in2: "Improve data integrity",
    average1in3: "Improve efficiency and quality",
    purchase: "Purchase Now",
    download: "Download",
    video: "Video",
    purchaseinfo: "Please call 400-991-7771 for a quote",
    coast: "Cost savings",
    average2: "Average savings",
    average2in1: "Shorten planning cycle",
    average2in2: "Simplify communication",
    average2in3: "Reduce stranded quantity",
    hubin: "BodorHub is an information acquisition system focused on Bodor laser cutting equipment",
    acquisition: "Data Acquisition",
    acquisitionin: "Support the collection of 34 cutting parameters and comprehensively monitor practical information of cutting equipment; Support viewing and exporting device operation logs, reports, and statistics",
    simple: "Simple and fast",
    simplein: "Docking third-party systems with HTTP protocol is simple and fast, and the system can provide docking examples and friendly development introduction cases",
    instant: "Instant View",
    instantin: "Real time push of speed, status, and other information through the weblock protocol, allowing devices to view real-time information at any time.",
    private: "Private deployment",
    privatein: "Fully supports private deployment, ensuring absolute data security and reliability.",
    hubin2: "In the hearts of every Bodor, customers are always the first priority",
    partners1: "OUR HUB' ",
    partners2: "PARTNERS",
    camin: "Supporting various industry-specific software and special customization of functions, the material utilization rate has increased by 15% compared to the old version, and the typesetting speed has increased by 25%. With a 10-year professional team, we have assisted in seamless connection of nesting and cutting.",
    contact1: "FEEL FREE TO ",
    contact2: "CONTACT US",
    question: "If you have any questions, please feel free to consult us at any time",
    email: "Email Address",
    emailin: "Enter Email",
    name: "Name",
    namein: "Please enter your name",
    message: "Message",
    submit: "Submit",
    copyright: "Bodor Inc©️2024copyright",
    login: "Login",
    home: "HOME",
    contactus: "CONTACT",
    visitor: "Visitor",
    tech: "Technical Support",
    techin: "You can access our knowledge base or download our software without logging in",
    techHeader: "Official Guide",
    techinfo1: "By accessing the knowledge base, you can view detailed guides provided by our developers to help you understand our devices, software, and operations",
    techinfo2: "By accessing the software download, you can view the updated instructions and historical versions of our CAM 2D and 3D cutting software, and download and use them. You can also view our official operation video",
    techBtn: "Learn More",
    nestin: "(sheet cutting)",
    tubein: "(tube cutting)",
    label: "label",
    labelin: "Please enter the article label",
    search: "search",
    reset: "reset",
    phone: "Accessing mobile devices",
    appin2: "To experience the full functionality, please scan the QR code below to download the Bodor+APP experience",
    appok: 'close',
    official: "Official Website",
  },
  login: {
    new: "New upgrade",
    choose: "Why Choose",
    info1: "Login to enjoy BodorNest Tube software",
    info2: "Log in and bind the device, monitor the device status in real-time",
    info3: "Login to view data statistics",
    noaccount: "No account",
    register: "Register Now",
    back: "back to home",
    login: "Login",
    account: "Account",
    enteraccount: "Please enter your account",
    enterpassword: "Please enter your passowrd",
    success: "login success",
    accountEmpty: "Account cannot be empty",
    passwordEmpty: "Password cannot be empty",
    forget: "forgot password?",
    resert: "Reset Password ",
    saveSuccess: "Modified Successfully",
    again: "Please obtain the verification code again",
    email: "Email",
    code: "Verification Code",
    nPassword: "New Password",
    nPasswordin: "Please enter your new password",
    confirm: "Confirm Password",
    confirmin: "Please confirm your password",
    noCode: "No verification code received",
    noCodein: "Please contact customer service to assist in resolving the issue of forgetting passwords",
    submit: "Submit",
  },
  register: {
    new: "New upgrade",
    register: "Register",
    account: "Account",
    password: "Password",
    confirm: "Confirm",
    email: "Email",
    name: "Name",
    phone: "Phone",
    address: "Address",
    accountin: "Please enter your account",
    passwordin: "Please enter your passowrd",
    confirmin: "Please confirm your passowrd",
    emailin: "Please enter your Email",
    namein: "Please enter your Name",
    phonein: "Please enter your Phone",
    codein: "Please enter your verification code",
    addressin1: "Please enter your Nation",
    addressin2: "Please enter your Province",
    addressin3: "Please enter your City",
    addressin4: "Please enter your County ",
    back: "back to login",
    accountEmpty: "Account cannot be empty",
    passwordEmpty: "Password cannot be empty",
    confirmEmpty: "The passwords entered twice are inconsistent",
    nameEmpty: "Name cannot be empty",
    emailEmpty: "Email cannot be empty",
    addressEmpty: "Address cannot be empty",
    phoneEmpty: "Phone cannot be empty",
    codeEmpty: "Verification code cannot be empty",
    success: "register success",
    emailError: "Please enter the correct email format",
    phoneError: "Please enter the correct phone format",
    emailDuplicate: "The email has been registered",
    code: "Email Verification",
    getCode: "Get Now",
    codeErr: "Verification code error!",
    wait: "Please Wait",
    subSuc: "Submitted Successfully",
    subInfo: "Your information has been submitted. Please contact customer service to manually register",
    noCode: "Not received",
    submit: "Submit",
    noCodein: "If you have not received the verification code, please click the submit button directly after checking this option to submit for manual review. Otherwise, please uncheck and fill in the verification code normally for registration"
  },
  index: {
    user: "User Center",
    myDevice: "My Device",
    task: "My Task",
    software: "Software",
    cam: "CAM",
    knowledge: "Konowledge Base",
    use: " Using knowledge",
    devicein: "Here, you can see the devices you are bound to. Click on the type to filter the corresponding devices, click on the device to enter and view device details, and click on add new device to bind a new device",
    screen: "Filter by type",
    all: "All types",
    add: "Add new device",
    order: "Order Number",
    orderin: "Please enter your order number",
    bind: "Bind Now",
    bindError: "The order number cannot be empty!",
    bindSuccess: "Binding successful!",
    report: "Processing report",
    reportin: "Here you can see the report of your own processing tasks",
    reporttb1: "Task Name",
    reporttb2: "Cutting Length",
    reporttb3: "Empty Length",
    reporttb4: "Start Time",
    reporttb5: "End Time",
    reporttb6: "File Name",
    reporttb7: "Punching Number",
    reporttb8: "Processing Time",
    time: "Processing time",
    timein: "Here you can see a list of your own processing time",
    timetb1: "Run Time",
    timetb2: "Idle Time",
    timetb3: "Offline Time",
    timetb4: "Creation Time",
    timetb5: "Stop Time",
    statistics: "Processing statistics",
    statisticsin: "Here you can see the statistics of your own processing task quantity and alarms",
    statisticsChart1: "Weekly statistics of task quantity",
    statisticsChart2: "Weekly statistics of alarm quantity",
    selectWeek: "Select a week",
    softwarein: "Here you can download our software",
    downloadNavi: "Download Navigation",
    downloadInfo: "Learn More",
    downloadWc: "Mini program side",
    downloadNest: "3D nesting software for the cutting industry",
    downloadTube: "Flat nesting software for the cutting industry",
    back: "Back",
    plusHeader1: "Exclusive",
    plusHeader2: " Customization",
    plusHeader3: "Perfect",
    plusHeader4: " Match",
    plusSlide: "Slide down to view more content",
    softwarePackage: "Software Package",
    download: "Download",
    updateInfo: "Update Logs",
    EnvirPackage: "Environment Package",
    video: "Video",
    video1: "Software login and usage process",
    video2: "Create tasks and import",
    video3: "One click settings",
    video4: "Automatic layout",
    video5: "Manual layout",
    video6: "Automatic sorting",
    video7: "Manual sorting",
    video8: "Layout Process Sorting",
    video9: "Edit common edge cutting path",
    video10: "Surplus materials",
    video11: "Skeleton chopping",
    video12: "Report form",
    video13: "Export NC",
    video14: "Automatic micro connection",
    video15: "External batch import",
    effect: "Effect",
    effect1: "The necessary environment for software operation",
    camin: "Here you can view the authorization status of CAM software",
    resources: "Related Resources",
    downloadInfo2: "Click on the download icon on the left to download the software",
    softwareName: "Software Name",
    softwareAuthor: "Software Type",
    newVersion: "Latest Version",
    updateTime: "Update Time",
    right1: "Version Comparison",
    right2: "Environment Package",
    right3: "Historical Version",
    right4: "Video Tutorial",
    right5: "Instructions",
    launch: "Click to expand/collapse article overview",
    myCam: "My Software Authorization",
    exchange: "Redemption of Points",
    exchangetb1: "Title",
    exchangetb2: "Original Price",
    exchangetb3: "Now Price",
    exchangetb4: "Preferential",
    exchangetb5: "Operation",
    exchangebtn: "exchange",
    camWarn: "Please log in to your CAM account first",
    accountConfirm: "Account Verification",
    name: "name",
    namein: "Please enter your name",
    account: "Job ID",
    accountin: "Please enter your Job ID",
    camInfo1: "License Code",
    camInfo2: "Product Name",
    camInfo3: "License Start Time",
    camInfo4: "License End Time",
    camInfo5: "License Validity Deadline",
    camInfo6: "License First Use Time",
    camInfo7: "Last Online Time",
    camInfo8: "Last Online Version",
    look: "check",
    knowledgetb1: "Title",
    knowledgetb2: "Label",
    knowledgetb3: "Language",
    knowledgetb4: "Create Time",
    knowledgetb5: "Operation",
    knowledgetb6: "Series",
    deviceInfo: "Device Info",
    deviceMonitor: "Device Monitoring",
    workTime: "Processing Time",
    workWeek: "Weekly Statistics",
    realTime: "Real-time Data ",
    repair: "Repair Report",
    repairin: "You can choose to self repair or consult customer service",
    workInfo: "Task Details",
    selectDay: "Select a day",
    workedTime: "Processed Duration",
    deviceName: "Device OrderNumber",
    deviceType: "Device Type",
    deviceStatus: "Device Status",
    deviceTask: "Current Task",
    run: "Run",
    idle: "Idle",
    offline: "Offline",
    stop: "Stop",
    sheet: "Sheet metal laser cutting machines",
    tube: "Tube metal laser cutting machines",
    runInfo: "Processing……",
    idleInfo: "Processing has not started",
    offlineInfo: "The device is offline",
    stopInfo: "Device emergency stop",
    x: "x-axis",
    y: "y-axis",
    z: "z-axis",
    w: "w-axis",
    speed: "Speed",
    power: "Power",
    pressure: "Pressure",
    contact: "Contact Information",
    contactin: "Please enter your contact information",
    name: "Name",
    namein: "Please enter your name",
    reson: "Reason",
    resonin: "Please enter your repair reason",
    submit: "Submit",
    cancel: "Cancel",
    jobErr: "Submission failed, please check if the username or job number is empty!",
    jobSuccess: "Verification successful!",
    exchangeSuccess: "Exchange successful!",
    left: "Remaining Progress",
    cutLength: "Cutting Length",
    emptyLength: "Empty Length",
    percent: "Feed Rate",
    number: "Number of parts",
    wsState1: "Device idle",
    wsState2: "Processing is starting",
    wsState3: "Device running",
    wsState4: "Device paused",
    wsState5: "Device pause",
    wsState6: "Device stopping",
    wsState7: "Device emergency stop in progress",
    wsState8: "Device emergency stop",
    wsState9: "Device offline",
    device: "Device",
    height: "Height",
    voltage: "Voltage",
    startTime: "Processing start time",
    endTime: "Processing end time",
    cutTime: "Cutting Time",
    emptyTime: "Null displacement Length",
    hole: "Hole Number",
    holeTime: "Hole Time",
    logOut: "Log Out",
    view: "Page View",
    videoin: `If you encounter a situation where full screen is not possible, right-click on the video and select "Open Video in New tab"`,
    videoList: "Video List",
    maintenance: "Maintenance",
    maintenancein: "Here, you can view equipment maintenance information and perform equipment maintenance",
    maintenance1: "Maintenance Items",
    maintenance1info: "Click the checkbox on the left side of the table to bind maintenance items to the corresponding device",
    maintenance2: "Maintenance And Upkeep",
    downloadCenter: "Download Center",
    autoQuery: "Automatically query input content",
    queryTree: "Please enter the directory name",
    noEmail: "The email has not been bound yet",
    noEmailin: "Detected that the email has not been bound yet, and some functions may not be able to be used. Do you want to go to the user center to bind it?",
    notNow: "Bind in the future",
    emailNow: "Go to bind",
    file: "Processing File",
    official: "Official Website",
    pierceCount: "Number of Perforations",
    pierceDuration: "Perforated Time",
    partCount: "Number of processed parts",
    guide:"01Product Manual",
		instructions:"02Operating System Instruction",
		guidance:"03On-site Assembly Manual",
		program:"04System Installer",
		scene:"05Site Layout Diagram",
		foundation:"06Foundation Diagram‌",
		hoisting:"07‌Lifting Diagram‌‌",
		electrical:"08Electrical Schematic diagram",
		cutting:"09‌Cutting Gas Circuit Schematic Diagram",
		waterway:"10Cooling Water Circuit Schematic Diagram",
		airCircuit:"11Actuating Pneumatic Circuit Schematic Diagram",
		lubrication:"12Lubrication System Diagram",
		hydraulic:"13Hydraulic Circuit Schematic Diagram",
		refrige:"14Refrigeration Circuit Schematic Diagram",
		product:"15product description",
		debug:"16Commissioning Work Instruction",
		repairHand:"17Maintenance Manual",
		automation:"20Automation Product Manual",
		homework:"21Operating System Instruction",
		indicate:"22‌Lifting Diagram‌‌",
		principle:"23Electrical Schematic diagram",
		autoElectrical:"24Actuating Pneumatic Circuit Schematic Diagram",
		autolubrication:"25Lubrication System Diagram",
		autohydraulic:"26Hydraulic Circuit Schematic Diagram",
		other:"other"
  },
  user: {
    aboutMe: "Aobut Me",
    basicInfo: "Basic Information",
    account: "Account",
    phone: "Phone",
    name: "Name",
    mail: "Email",
    address: "Address",
    oldPass: "Old Password",
    newPass: "New Password",
    confirmPass: "Confirm Password",
    passwordIn: "If you don't need to change your password, please leave it blank",
    device: "Owning Devices",
    save: "Save",
    nameErr: "Name cannot be empty!",
    phoneErr: "Phone number format error!",
    oldErr: "Old password cannot be empty!",
    newErr: "The passwords entered twice are inconsistent!",
    vip: "Vip Growth Level",
    toGrowth: "Go and upgrade the vip level",
    level1: "Regular Vip",
    level2: "Silver Vip",
    level3: "Gold Vip",
    level4: "Platinum Vip ",
    level5: "Diamond Vip",
    gValue: "Growth Value",
    next1: "We still need",
    next2: "points",
    warranty: "Warranty Information",
    orderin: "Please enter the order number",
    search: "Search",
    reset: "Reset",
    getdeviceerr: "Failed to obtain user device!",
    orderNumber: "Order Number",
    deliveryTime: "Delivery Time",
    marketingDept: "Marketing Department",
    belongDept: "Belong Department",
    laserBrand: "Laser Brand",
    extdWarrantyTime: "Extended Warranty Time",
    guaranteeTime: "Warranty Period",
    isGuarantee: "Is Warranty",
    extdWarrantyType: "Extended Warranty Type",
    changeEmail: "Bind/Change Email",
    question: "Problem feedback",
    questionin: "Please enter the question title",
    questionTitle: "Title",
    product: "Product",
    version: "Version",
    person: "Name",
    contact: "Contact Information",
    time: "Submission Time",
    processingStatus: "Processing Status",
    isComplaint: "Is Urgent",
    newQuestion: 'Feedback submission',
    action: "action",
    complaint: "urgent",
    urgent: "Urgent Order",
    noUrgent: "Not Urgent",
    progress: "in progress",
    completed: "Completed",
    ended: "Ended",
    urgented: "Urgent",
    urgentsucc: "Urgent successful, the engineer will receive an urgent reminder and prioritize processing for you",
    check: "check",
    questionTitle: "Feedback Details",
    want: "Estimated Processing Time",
    reality: "Actual Processing Time",
    step: "Repro Steps",
    file: " files",
    code: "Email Verification",
  },
  uk: {
    random: "Random Files",
    guide: "Operation Guide",
    download: "Software Download",
    common: "Common Faults",
    wait: "Stay Tuned",
  },
  visitor: {
    back: "Back",
  },
  repair: {
    online: "Online Service",
    common: "Self Service",
    click: "Submit Questions",
    repairtb1: "Title",
    repairtb2: "Label",
    repairtb3: "Operation",
  },
  click: {
    work: "Work order submission",
    order: "Order Number",
    devicein: "Please select your device",
    suberr: "Please check for formatting errors and resubmit",
    phone: "Phone Number",
    phonein: "Please enter your phone number",
    phoneerr: "Please enter the correct formatted phone number",
    email: "Email",
    emailin: "Please enter your email address",
    emailerr:"Please enter the correct email format",
    company: "Company",
    companyin: "Please enter your company",
    province: "Province",
    provincein: "Please select your province",
    city: "City",
    cityin: "Please select your city",
    content: "Content",
    contentin: "Please enter your submission content",
    notnow: "Save Draft",
    submit: "Submit",
    event: "Work Order Number",
    eventin: "Please enter the work order number",
    search: "Search",
    resert: "Reset",
    newevent: "Submit Work Order",
    status1: "Processing",
    status2: "Completed",
    status3:  "Pending",
    createTime: "Create Time",
    look: "View",
    detail: "Work Order Details",
    basic: "Basic information",
    eventNum: "Work Order Number",
    ownOrder: "Order Number",
    ownUser: "Reporting Person",
    ownCopany:  "Reporting Company",
    ownTime: "Reporting time",
    ownEmail: "Submission email",
    ownAddress:  "Reporting Address",
    Owncontent: "Description",
    status: "Work Order Status",
    des1: "To be assigned to an engineer or to be processed by an engineer",
    des2: "The engineer will process the work order for you",
    des3: "The work order has been processed",
    action: "Operation",
    success: "Submitted successfully!",
    successin: "The current work order number is:",
    worker: "Service and Evaluation",
    evaluate: "Evaluation Engineer",
    spareTitle:"Fault Type",
    spareContent:"Please select spare parts",
    inventoryTitle:"Spare Part Inventory",
    inventoryContent:"Please enter spare parts inventory",
    stock:"Spare Part Inventory",
    spareCode:"Spare parts code",
    spareName:"Spare parts name",
    specs:"specifications",
    size:"size",
    Threshold:"Inventory threshold",
    edit:"edit"
  },
  main: {
    title1: "Maintenance Details",
    project: "Maintenance Project",
    orderNumber: "Order Number",
    realName: "Personnel Name",
    content: "Maintenance Content",
    label: "Maintenance Label",
    cycle: "Maintenance Cycle(h)",
    surplus: "Expiration Time(h)",
    createTime: "Create Time",
    warningHours: "Early Warning(h)",
    warningTime: "Warning Time",
    isEnabled: "Is Enabled",
    isNormal: "Maintenance Status",
    confirm: "Confirm Maintenance",
    title2: "Maintenance Records",
    disabled: "Disabled",
    enabled: "Enabled",
    overdue: "Overdue",
    normal: "Normal",
    maintain: "Maintain",
    action: "Action",
    name: "Maintenance Personnel",
    time: "Maintenance Date",
    yes: "Yes",
    no: "No",
    pleaseSelect: "Please select a maintenance date!",
  },
  service: {
    center: "Service Center",
    policy: "Service Policy",
    standards: "Service Standard",
    verify: "Verify Login",
    account: "Account",
    accountin: "Please enter your account!",
    password: "Password",
    passwordin: "Please enter your password!",
    submit: "Submit",
    orderNumber: "Order Number",
    orderin: "Please enter the order number!",
    search: "Search",
    reset: "Reset",
    deviceName: "Device Name",
    deviceSeries: "Device Series",
    deviceModel: "Device Model",
    language: "Language",
    version: "Version Number",
    operation: "Operation",
    view: "View",
    deviceInfo: "Device Info",
    randomFile: "Random File",
    download: "Download",
    power: "Rated Power",
    voltage: "Rated Voltage",
    current: "Full-load Current",
    shortCircuit: "Short-circuit Rating",
    frequency: "Frequency",
    date: "Manufacturing Date",
    warranty: "Number of Warranty Days",
    encryption: "Encryption",
    remarks: "Remarks",
    fileName: "File Name",
    machineType: "Machine Type",
    cuttingMachine: "Complete Cutting Machine",
    weldingMachine: "Complete Welding Machine",
    fileType: "File Classification",
    success: "Verification successful!",
    error: "Validation failed!",
    noData: "No data available at the moment",
  },
  camReport: {
    camReport: "CAM Issue Feedback",
    product: "Product",
    productin: "Please enter the product you belong to",
    version: "Version",
    versionin: "Please enter the version number",
    name: "Name",
    namein: "Please enter your name",
    phone: "Phone",
    phonein: "Please enter your contact information",
    title: "Issue Title",
    titlein: "Please enter the issue title",
    step: "Repro Steps",
    stepin: "Please enter the reproduction step",
    bnt: "bnt File",
    bntin: "Please upload the bnt file",
    bnn: "bnn File",
    bnnin: "Please upload the bnn file",
    other: "igs/stp File",
    otherin: "Please upload the igs/stp file",
    other2: "dxf/dwg File",
    otherin2: "Please upload the dxf/dwg file",
    submit: "Submit",
    error: "URL error",
    errorin: "Please return to the CAM software and redirect to the link again",
    success: "Submitted successfully",
    successin: "You can use the phone number provided during submission to register for a Bodor+account, check the processing status, and perform urgent operations",
    registerUrl: "Registration website: ",
    app: "Or scan the QR code below to experience using the WeChat mini program:",
    nosupport: "Uploading this type of file is not supported",
    uploadsucc: "Upload Successful",
    uploaderror: "Upload Failed",
    import: "import",
    exTime: "Expected time",
    exTimein: "Please select the expected processing completion time",
    phoneerr: "Please enter the correct format of your phone number or email address",
  },
  userReport: {
    userReport: "Bodor+ Issue Feedback",
    product: "Product",
    productin: "Please select the product you belong to",
    version: "Version",
    versionin: "Please enter the version number",
    name: "Name",
    namein: "Please enter your name",
    phone: "Phone",
    phonein: "Please enter your contact information",
    title: "Issue Title",
    titlein: "Please enter the issue title",
    step: "Repro Steps",
    stepin: "Please enter the reproduction step",
    bnt: "bnt File",
    bntin: "Please upload the bnt file",
    bnn: "bnn/bnd File",
    bnnin: "Please upload the bnn/bnd file",
    other: "igs/stp File",
    otherin: "Please upload the igs/stp file",
    other2: "dxf/dwg File",
    otherin2: "Please upload the dxf/dwg file",
    another: "annex",
    anotherin: "Please upload other files",
    submit: "Submit",
    error: "User information error",
    errorin: "Please return to Bodor and log in again",
    success: "Submitted successfully",
    successin: "You can view the progress of submitted feedback processing or make urgent actions on the personal center page",
    registerUrl: "Registration website: ",
    app: "You can also scan the QR code below and use the WeChat mini program to experience the same content",
    nosupport: "Uploading this type of file is not supported",
    uploadsucc: "Upload Successful",
    uploaderror: "Upload Failed",
    import: "import",
    exTime: "Expected time",
    exTimein: "Please select the expected processing completion time",
    phoneerr: "Please enter the correct format of your phone number or email address",
  },
  file: {
    orderNumber: "Order Number",
    fileName: "File Name",
    createTime: "Create Time",
    title: "Industrial file cloud push",
    titlein: "You can push your industrial files here safely, quickly, reliably, and conveniently",
    upload: "Click to Upload",
    drawerTitle1: "Upload New File",
    selectFile: "Select File",
    delete: "Delete",
    deletein: "Are you sure to delete this file?",
    uFile: "Upload files",
    uploadBox: "Click or drag a new file here",
    close: "Close",
    submit: "Upload",
    submitError: "The file name contains special characters such as+, please modify the file name and upload again!",
    success: "Upload successful!",
    fail: "Upload failed!",
    fail1: "Failed to obtain device industrial file interface request! reason:",
    fail2: "Failed to obtain user device list interface request! reason:",
    faile3: "Failed to delete industrial file interface request! reason:",
    faile4: "Failed to obtain processing report interface request! reason:",
    faile5: "Failed to obtain CAM machining report interface request! reason:",
    searchErr: "Please enter the file name!",
    search: "Enter file name to retrieve industrial files",
    workReport: "Processing Records",
    processType: "Process Type",
    thickness: "Thickness",
    partCount: "Number of Parts",
    pierceCount: "Number of Perforations",
    pierceDuration: "Perforated Time(ms)",
    PerforationTime: "Perforated Time(s)",
    idleLength: "Idle Travel Distance(m)",
    idleTime: "Idle Travel Time(s)",
    slicingLength: "Cutting Length(m)",
    slicingDuration: "Cutting Time(ms)",
    cutTime: "Cutting Time(s)",
    totalDuration: "Processing Time(ms)",
    processingTime: "Processing Time(s)",
    startTime: "Processing Start Time",
    endTime: "Processing End Time",
    useTubeCount: "Quantity of Tubing Used",
    isComplete: "Completion Status",
    fileName: "Processing Documents",
    completed: "Completed",
    notCompleted: "Incomplete",
    process: "Process",
    emptyOperation: "Epty Operation",
    machineName: "Device Name",
    createTime: "Creation Time",
    camReport: "CAM Report",
    camReportSheet1: "CAM Sheet Information (Sheet Cutting Machine)",
    camReportSheet2: "CAM PartS Information (Sheet Cutting Machine)",
    Material: "Material",
    TaskName: "Task Name",
    PlateSize: "Plate Size",
    Thickness: "Plate Thickness",
    Density: "Plate Density",
    PlateCount: "Number of Plates (Sheets)",
    PlateWeight: "Weight of Plates(Kg)",
    PlateName: "Plate Name",
    UtilizationRate: "Utilization Rate",
    NestName: "Nesting Name",
    camReportTube1: "CAM Report(Tube Cutting Machine)",
    camReportTube2: "CAM Nesting Information(Tube Cutting Machine)",
    camReportTube3: "CAM Parts Information(Tube Cutting Machine)",
    camReportTube4: "CAM Tubing Information(Tube Cutting Machine)",
    ProjectName: "Project Name",
    CreateTime: "Creation Time",
    Gap: "Edge Allowance(mm)",
    CutLength: "Cut Off Distance(mm)",
    Material2: "Material",
    TubeInfo: "Tube Info",
    TubeThickness: "Tube Thickness(mm)",
    SectionInfo: "Specifications",
    SectionType: "Tube Type",
    Code: "Single Part Code",
    Name: "Single Part Name",
    Size: "Single Part Size",
    Count: "Single Part Count",
    Weight: "Single Part Weight(g)",
    LayoutQuantity: "Nesting Quantity",
    SurPlusQuantity: "Remaining Quantity of Parts",
    PartCutLength: "Single Part Cutting Length(m)",
    ID: "ID",
    NestTubeID: "Tube ID",
    Sort: "Nesting Sort",
    SortName: "Nesting Tube Name",
    Length: "Total Length of Tube",
    SurplusLength: "Remaining Length",
    UsedTubeCount: "Quantity of Tube Used",
    Count2: "Quantity",
    CutLength2: "Total Cutting Length",
    AirLength: "Idle Travel Distance",
    PerforationCount: "Number of Perforations",
    Sort2: "Part Sort",
    Name2: "Part Name",
    Size2: "Part Size",
    Weight2: "Part Weight",
    Count3: "Total Number of Parts",
    UsedCount: "Number of Parts Nested",
    SurplusCount: "Remaining Quantity of Parts",
    Name3: "Tube Nmae",
    Sort3: "Tube Sort",
    Section: "Tube Cross-section",
    Length2: "Tube Length",
    Count4: "Total Quantity of Tubes",
    UsedCount2: "Quantity of Tubes Used",
    SurplusCount2: "Remaining Tubes",
    img: "Parts Thumbnail",
    sheetImg: "Sheet Thumbnail",
    downloadReport: "Download",
  },
  information:{
    new: "Newly Upgraded",
    title:"Information Collection",
    register:"Submit",
    people:"Contacts",
    peoplein:"Please enter the name of the contact person",
    peopleEmpty: "Contact person cannot be empty",
    email:"Email",
    emailEmpty:"Email cannot be empty",
    emailError: "Please enter the correct email format",
    company:"Corporate Name",
    companyin:"Please enter the company name",
    companyEmpty:"The company name cannot be empty",
    address:"Address",
    addressin:"Please enter the address",
    addressEmpty:"The address cannot be empty",
  }
}